/**
 * motiq.js — Product page interactivity
 * Upload to: Online Store > Themes > Edit code > Assets > Add a new asset
 *
 * Handles:
 *  - Vehicle make/model dropdown cascade
 *  - Y-cable upsell toggle
 *  - Rego field (auto-uppercase)
 *  - AJAX add-to-cart (main product + optional Y-cable)
 *    with line item properties for rego, vehicle, and cable type
 */

/* ═══════════════════════════════════════════════════════════
   VEHICLE DATA
   Edit this section to add/remove makes and models.
   cable values: "standard" = Toyota/Nissan Y-Cable
                 "vag"      = VW/Audi Y-Cable
                 "splitter" = OBD Splitter Cable
   ═══════════════════════════════════════════════════════════ */
var CABLE_LABELS = {
  standard: 'Toyota/Nissan Y-Cable',
  vag:      'VW/Audi Y-Cable',
  splitter: 'OBD Splitter Cable'
};

var MOTIQ_VEHICLES = {
  "Toyota":        { cable: "standard", models: ["Corolla","Corolla Cross","Camry","Camry Hybrid","RAV4","RAV4 Hybrid","RAV4 PHEV","HiLux","LandCruiser 70 Series","LandCruiser 200 Series","LandCruiser 300 Series","Prado","Kluger","Kluger Hybrid","Yaris","Yaris Cross","C-HR","Fortuner","HiAce","Tarago","Prius","Prius C","GR Corolla","GR86","Supra"] },
  "Ford":          { cable: "standard", models: ["Ranger","Ranger Raptor","Everest","Puma","Escape","Mustang","Mustang Mach-E","Transit","Transit Custom","Bronco","F-150"] },
  "Hyundai":       { cable: "standard", models: ["i30","i30 N","i20","i20 N","Tucson","Tucson Hybrid","Tucson PHEV","Santa Fe","Santa Fe Hybrid","Kona","Kona Electric","Kona N","Venue","Staria","Ioniq 5","Ioniq 6","Palisade"] },
  "Mazda":         { cable: "standard", models: ["Mazda2","Mazda3","Mazda3 SP25","CX-3","CX-30","CX-5","CX-60","CX-8","CX-90","MX-5","BT-50"] },
  "Kia":           { cable: "standard", models: ["Cerato","Stinger","Sportage","Sportage PHEV","Sorento","Sorento PHEV","Seltos","Stonic","Picanto","Tasman","EV3","EV6","EV9","Carnival"] },
  "Mitsubishi":    { cable: "standard", models: ["Triton","Triton GSR","Outlander","Outlander PHEV","Eclipse Cross","Eclipse Cross PHEV","ASX","Pajero Sport","Pajero","Express"] },
  "Nissan":        { cable: "standard", models: ["Navara","Patrol","Patrol Y62","X-Trail","Qashqai","Juke","Pathfinder","Murano","Leaf","Ariya"] },
  "Isuzu":         { cable: "standard", models: ["D-Max","D-Max X-Terrain","MU-X"] },
  "Subaru":        { cable: "standard", models: ["Impreza","WRX","WRX STI","Forester","Outback","Liberty","XV","Crosstrek","BRZ","Solterra"] },
  "Honda":         { cable: "standard", models: ["Civic","Civic Type R","Accord","HR-V","CR-V","CR-V e:HEV","Jazz","ZR-V","Odyssey","BR-V"] },
  "Lexus":         { cable: "standard", models: ["IS","ES","GS","LS","UX","UX 300e","NX","NX 350h","NX 450h+","RX","RX 500h","GX","LX","LC"] },
  "Suzuki":        { cable: "standard", models: ["Swift","Swift Sport","Vitara","Vitara Turbo","S-Cross","Jimny","Jimny Sierra","Baleno","Ignis"] },
  "MG":            { cable: "standard", models: ["MG3","MG4","ZS","ZST","HS","MG S5 EV"] },
  "GWM / Haval":   { cable: "standard", models: ["Haval Jolion","Haval H6","Haval H6 GT","Haval H9","GWM Ute","GWM Cannon","GWM Cannon Alpha","GWM Tank 300","GWM Tank 500"] },
  "BYD":           { cable: "standard", models: ["Atto 3","Seal","Sealion 6","Sealion 7","Dolphin","Shark"] },
  "Tesla":         { cable: "standard", models: ["Model 3","Model Y","Model S","Model X","Cybertruck"] },
  "LDV":           { cable: "standard", models: ["T60","T60 Max","G10","G10 Plus","MIFA 9","eT60","eDeliver 9"] },
  "Jeep":          { cable: "standard", models: ["Wrangler","Gladiator","Cherokee","Grand Cherokee","Grand Cherokee L","Compass","Renegade"] },
  "Peugeot":       { cable: "standard", models: ["208","2008","308","3008","5008","408","508","Rifter","Expert"] },
  "Renault":       { cable: "standard", models: ["Clio","Megane","Arkana","Koleos","Captur","Trafic","Master","Zoe","Megane E-Tech","Symbioz"] },
  "Chery":         { cable: "standard", models: ["Omoda 5","Omoda E5","Tiggo 4","Tiggo 7 Pro","Tiggo 8 Pro"] },
  "Holden":        { cable: "standard", models: ["Colorado","Trailblazer","Commodore","Commodore Wagon","Commodore Ute","Captiva","Trax","Astra","Cruze","Barina","Spark"] },
  "RAM":           { cable: "standard", models: ["1500","2500"] },
  "Alfa Romeo":    { cable: "standard", models: ["Giulia","Giulia Quadrifoglio","Stelvio","Stelvio Quadrifoglio","Tonale"] },
  "Volkswagen":    { cable: "vag",      models: ["Golf","Golf GTI","Golf R","Golf Wagon","Polo","T-Roc","Tiguan","Tiguan Allspace","Touareg","Passat","Amarok","Amarok V6","Multivan","Caravelle","Transporter","Caddy","ID.4"] },
  "Audi":          { cable: "vag",      models: ["A1","A3","A3 Sedan","A4","A4 Allroad","A5","A6","A7","A8","Q2","Q3","Q5","Q7","Q8","TT","R8","e-tron","Q4 e-tron","Q8 e-tron"] },
  "Skoda":         { cable: "vag",      models: ["Octavia","Octavia RS","Superb","Kodiaq","Karoq","Kamiq","Fabia","Enyaq"] },
  "SEAT / Cupra":  { cable: "vag",      models: ["Cupra Formentor","Cupra Born","Cupra Leon","Ateca","Tarraco"] },
  "Porsche":       { cable: "vag",      models: ["911","718 Cayman","718 Boxster","Cayenne","Macan","Panamera","Taycan"] },
  "BMW":           { cable: "splitter", models: ["1 Series","2 Series","2 Series Gran Coupe","3 Series","3 Series Touring","4 Series","5 Series","7 Series","X1","X2","X3","X4","X5","X7","i4","iX","iX1","iX3","M2","M3","M4","M5"] },
  "Mercedes-Benz": { cable: "splitter", models: ["A-Class","B-Class","C-Class","C-Class Estate","E-Class","E-Class Estate","S-Class","GLA","GLB","GLC","GLE","GLS","Vito","Sprinter","V-Class","EQA","EQB","EQC","EQE","EQS"] },
  "Volvo":         { cable: "splitter", models: ["XC40","XC60","XC90","V60","V90 Cross Country","S60","C40 Recharge","EX30","EX90"] },
  "Land Rover":    { cable: "splitter", models: ["Defender","Discovery","Discovery Sport","Range Rover","Range Rover Sport","Range Rover Evoque","Range Rover Velar"] }
};

(function () {
  'use strict';

  /* ─────────────────────────────────────────────
     CONFIG — variant IDs injected by Liquid snippet
     See motiq-product-extras.liquid
     ───────────────────────────────────────────── */
  const cfg = window.motiqConfig || {};
  // cfg.mainVariantId   — Shopify variant ID of the GPS tracker
  // cfg.ycableVariantId — Shopify variant ID of the Y-cable

  /* ─────────────────────────────────────────────
     STATE
     ───────────────────────────────────────────── */
  let upsellSelected = false;

  /* ─────────────────────────────────────────────
     DOM REFS — resolved after DOMContentLoaded
     ───────────────────────────────────────────── */
  let upsellCard, makeSelect, modelSelect, vehicleWarning;
  let regoInput, addBtn, btnLabel, spinner, errorMsg;

  /* ════════════════════════════════════════════
     INIT
     ════════════════════════════════════════════ */
  document.addEventListener('DOMContentLoaded', function () {

    upsellCard     = document.getElementById('mq-upsell-card');
    makeSelect     = document.getElementById('mq-make');
    modelSelect    = document.getElementById('mq-model');
    vehicleWarning = document.getElementById('mq-vehicle-warning');
    regoInput      = document.getElementById('mq-rego');
    addBtn         = document.getElementById('mq-add-btn');
    btnLabel       = document.getElementById('mq-btn-label');
    spinner        = document.getElementById('mq-spinner');
    errorMsg       = document.getElementById('mq-error');

    if (!addBtn) return; // Not on a product page with our snippet

    // ── Vehicle selector ──
    if (makeSelect) {
      populateMakes();
      makeSelect.addEventListener('change', onMakeChange);
    }

    if (modelSelect) {
      modelSelect.addEventListener('change', onModelChange);
    }

    // ── Upsell toggle ──
    const upsellHeader = document.getElementById('mq-upsell-header');
    if (upsellHeader) {
      upsellHeader.addEventListener('click', toggleUpsell);
      // Allow keyboard activation
      upsellHeader.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleUpsell();
        }
      });
    }

    // ── Rego auto-uppercase ──
    if (regoInput) {
      regoInput.addEventListener('input', function() {
        const pos = regoInput.selectionStart;
        regoInput.value = regoInput.value.toUpperCase().replace(/[^A-Z0-9 ]/g, '');
        regoInput.setSelectionRange(pos, pos);
      });
    }

    // ── Add to cart ──
    addBtn.addEventListener('click', handleAddToCart);

    updateButtonLabel();
  });


  /* ════════════════════════════════════════════
     VEHICLE SELECTOR
     ════════════════════════════════════════════ */

  function populateMakes() {
    Object.keys(MOTIQ_VEHICLES).sort().forEach(function(make) {
      const opt = document.createElement('option');
      opt.value = make;
      opt.textContent = make;
      makeSelect.appendChild(opt);
    });
    const other = document.createElement('option');
    other.value = 'other';
    other.textContent = 'Other / Not listed';
    makeSelect.appendChild(other);
  }

  function onMakeChange() {
    const make = makeSelect.value;
    modelSelect.innerHTML = '<option value="">Select model</option>';
    vehicleWarning.classList.remove('is-visible');

    if (!make) {
      modelSelect.disabled = true;
      return;
    }

    if (make === 'other') {
      modelSelect.disabled = true;
      vehicleWarning.classList.add('is-visible');
      vehicleWarning.textContent =
        'Your vehicle isn\'t listed — please contact us at info@motiq.com.au before ordering the Y-cable to confirm compatibility.';
      return;
    }

    const entry  = MOTIQ_VEHICLES[make];
    const models = entry ? entry.models : [];
    models.forEach(function(model) {
      const opt = document.createElement('option');
      opt.value = model;
      opt.textContent = model;
      modelSelect.appendChild(opt);
    });
    modelSelect.disabled = false;
  }

  function onModelChange() {
    vehicleWarning.classList.remove('is-visible');
  }


  /* ════════════════════════════════════════════
     UPSELL TOGGLE
     ════════════════════════════════════════════ */

  function toggleUpsell() {
    upsellSelected = !upsellSelected;
    upsellCard.classList.toggle('is-selected', upsellSelected);

    // Reset vehicle fields when deselecting
    if (!upsellSelected) {
      if (makeSelect)  makeSelect.value  = '';
      if (modelSelect) { modelSelect.innerHTML = '<option value="">Select model</option>'; modelSelect.disabled = true; }
      if (vehicleWarning) vehicleWarning.classList.remove('is-visible');
    }

    updateButtonLabel();
  }


  /* ════════════════════════════════════════════
     BUTTON LABEL
     ════════════════════════════════════════════ */

  function updateButtonLabel() {
    if (!btnLabel) return;
    const total = 99 + (upsellSelected ? 29 : 0);
    btnLabel.textContent = 'Add to Cart — $' + total;
  }


  /* ════════════════════════════════════════════
     VALIDATION
     ════════════════════════════════════════════ */

  function validate() {
    clearError();

    const rego = regoInput ? regoInput.value.trim() : '';
    if (!rego) {
      showError('Please enter your vehicle registration plate.');
      regoInput && regoInput.focus();
      return false;
    }

    if (upsellSelected) {
      if (!makeSelect || !makeSelect.value) {
        showError('Please select your vehicle make for the Y-cable.');
        makeSelect && makeSelect.focus();
        return false;
      }
      if (makeSelect.value !== 'other' && (!modelSelect || !modelSelect.value)) {
        showError('Please select your vehicle model for the Y-cable.');
        modelSelect && modelSelect.focus();
        return false;
      }
    }

    return true;
  }


  /* ════════════════════════════════════════════
     ADD TO CART
     Adds main product + optional Y-cable in one
     request using Shopify's Cart API
     ════════════════════════════════════════════ */

  function handleAddToCart(e) {
    e.preventDefault();
    if (!validate()) return;

    const rego  = regoInput.value.trim().toUpperCase();
    const make  = makeSelect  ? makeSelect.value  : '';
    const model = modelSelect ? modelSelect.value : '';

    // Build items array
    const items = [];

    // 1. Main product — GPS tracker
    const trackerItem = {
      id:         cfg.mainVariantId,
      quantity:   1,
      properties: {
        'Vehicle Registration': rego
      }
    };
    items.push(trackerItem);

    // 2. Monthly Tracking Plan (always added as subscription)
    items.push({
      id:            cfg.trackingPlanVariantId,
      quantity:      1,
      selling_plan:  2749497515
    });

    // 3. Y-cable (if selected)
    if (upsellSelected && cfg.ycableVariantId) {
      // Resolve cable type for packer
      const makeEntry  = MOTIQ_VEHICLES[make];
      const cableKey   = (makeEntry && makeEntry.cable) ? makeEntry.cable : 'standard';
      const cableLabel = CABLE_LABELS[cableKey] || cableKey;

      const ycableItem = {
        id:         cfg.ycableVariantId,
        quantity:   1,
        properties: {
          'Cable Type': cableLabel
        }
      };
      if (make)  ycableItem.properties['Vehicle Make']  = make;
      if (model) ycableItem.properties['Vehicle Model'] = model;
      items.push(ycableItem);
    }

    setLoading(true);

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ 
        items: items,
        note:  rego
      })
    })
    .then(function(res) {
      if (!res.ok) return res.json().then(function(d) { throw new Error(d.description || 'Could not add to cart.'); });
      return res.json();
    })
    .then(function() {
      // Redirect straight to checkout
      window.location.href = '/checkout';
    })
    .catch(function(err) {
      setLoading(false);
      showError(err.message || 'Something went wrong. Please try again.');
    });
  }


  /* ════════════════════════════════════════════
     UI HELPERS
     ════════════════════════════════════════════ */

  function setLoading(on) {
    if (!addBtn) return;
    addBtn.disabled = on;
    addBtn.classList.toggle('is-loading', on);
  }

  function showError(msg) {
    if (!errorMsg) return;
    errorMsg.textContent = msg;
    errorMsg.classList.add('is-visible');
    errorMsg.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function clearError() {
    if (!errorMsg) return;
    errorMsg.textContent = '';
    errorMsg.classList.remove('is-visible');
  }

})();


/* ═══════════════════════════════════════════════════════════
   STANDALONE CABLE PAGE
   Runs when motiqCableConfig is present (cable product page only)
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    const cfg = window.motiqCableConfig;
    if (!cfg || !document.getElementById('mq-cable-extras')) return;

    const makeSelect  = document.getElementById('mq-cable-make');
    const modelSelect = document.getElementById('mq-cable-model');
    const typeDisplay = document.getElementById('mq-cable-type-display');
    const typeLabel   = document.getElementById('mq-cable-type-label');
    const warning     = document.getElementById('mq-cable-warning');
    const errorMsg    = document.getElementById('mq-cable-error');
    const addBtn      = document.getElementById('mq-cable-add-btn');

    // ── Populate makes from built-in MOTIQ_VEHICLES ──
    Object.keys(MOTIQ_VEHICLES).sort().forEach(function (make) {
      const opt = document.createElement('option');
      opt.value = make;
      opt.textContent = make;
      makeSelect.appendChild(opt);
    });
    const other = document.createElement('option');
    other.value = 'other';
    other.textContent = 'Other / Not listed';
    makeSelect.appendChild(other);

    // ── Make change ──
    makeSelect.addEventListener('change', function () {
      const make = makeSelect.value;
      modelSelect.innerHTML = '<option value="">Select model...</option>';
      modelSelect.disabled = true;
      typeDisplay.style.display = 'none';
      warning.textContent = '';
      warning.classList.remove('is-visible');

      if (!make) return;

      if (make === 'other') {
        warning.textContent = 'Your vehicle isn\'t listed — contact us at info@motiq.com.au to confirm compatibility before ordering.';
        warning.classList.add('is-visible');
        return;
      }

      const entry     = MOTIQ_VEHICLES[make];
      const models    = entry ? entry.models : [];
      const cableKey  = entry ? entry.cable : 'standard';
      const cableName = CABLE_LABELS[cableKey] || cableKey;

      typeLabel.textContent = cableName;
      typeDisplay.style.display = 'block';

      models.forEach(function (model) {
        const opt = document.createElement('option');
        opt.value = model;
        opt.textContent = model;
        modelSelect.appendChild(opt);
      });
      modelSelect.disabled = false;
    });

    // ── Add to cart ──
    addBtn.addEventListener('click', function () {
      clearError();
      const make  = makeSelect.value;
      const model = modelSelect.value;

      if (!make) {
        showError('Please select your vehicle make.');
        makeSelect.focus();
        return;
      }
      if (make !== 'other' && !model) {
        showError('Please select your vehicle model.');
        modelSelect.focus();
        return;
      }

      const entry      = MOTIQ_VEHICLES[make];
      const cableKey   = entry ? entry.cable : 'standard';
      const cableLabel = CABLE_LABELS[cableKey] || cableKey;

      const item = {
        id:         cfg.ycableVariantId,
        quantity:   1,
        properties: {
          'Cable Type': cableLabel
        }
      };
      if (make)  item.properties['Vehicle Make']  = make;
      if (model) item.properties['Vehicle Model'] = model;

      setLoading(true);
      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    JSON.stringify({ items: [item] })
      })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Could not add to cart.'); });
        return res.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function (err) {
        setLoading(false);
        showError(err.message || 'Something went wrong. Please try again.');
      });

      function setLoading(on) {
        addBtn.disabled = on;
        addBtn.classList.toggle('is-loading', on);
      }
      function showError(msg) {
        errorMsg.textContent = msg;
        errorMsg.classList.add('is-visible');
      }
      function clearError() {
        errorMsg.textContent = '';
        errorMsg.classList.remove('is-visible');
      }
    });
  });

})();
